import { Fragment } from 'react';
import { FormDetailEditor } from './FormDetailEditor';
import { TrackingHeadTitle } from '../TrackingHeadTitle';
import styles from '../styles.module.scss';

export const FormEditors = (props) => {
  const {
    agents,
    clients,
    viewOnly,
    formDetails,
    handleMessage,
    handleResendForm,
    handleRemoveEditor,
    setReplaceEntityModal,
  } = props;

  const { isCompleted, editors } = formDetails;
  const { Client, Agent } = editors;

  const hasClientUsers = Client.users?.length > 0;
  const hasAgentUsers = Agent.users?.length > 0;

  if (!hasClientUsers && !hasAgentUsers) return null;

  return (
    <Fragment>
      {!isCompleted && <TrackingHeadTitle title="Editors" />}

      {hasClientUsers && (
        <div className={styles.trackingTabItems}>
          {Client.users.map((val, index) => (
            <div key={index}>
              <FormDetailEditor
                item={val}
                role="Client"
                options={clients}
                viewOnly={viewOnly}
                handleResendForm={handleResendForm}
                setReplaceEntityModal={setReplaceEntityModal}
                handleRemoveEditor={handleRemoveEditor}
                handleMessage={handleMessage}
              />
            </div>
          ))}
        </div>
      )}

      {hasAgentUsers && (
        <div className={styles.trackingTabItems}>
          {Agent.users.map((val, index) => (
            <div key={index}>
              <FormDetailEditor
                item={val}
                role="Agent"
                options={agents}
                viewOnly={viewOnly}
                handleResendForm={handleResendForm}
                setReplaceEntityModal={setReplaceEntityModal}
                handleRemoveEditor={handleRemoveEditor}
                handleMessage={handleMessage}
              />
            </div>
          ))}
        </div>
      )}
    </Fragment>
  );
};
